import React from "react";

function FormattedDate(props) {
  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let day = days[props.date.getDay()];
  let hours = props.date.getHours();
  if (hours < 10) {
    hours = `0${hours}`;
  }

  let minutes = props.date.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  let date = props.date.getDate();
  let month = props.date.getMonth() + 1;
  let year = props.date.getFullYear();
  return (
    <div>
      <p>
        {day} {date}/{month}/{year} {hours}:{minutes}
      </p>
    </div>
  );
}

export default FormattedDate;
